import { Component, OnInit } from '@angular/core';
import { AppStorage } from './shared/services/appStorage.service';
import { LoginService } from './shared/services/login.service';
import { Router, NavigationStart } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'IFCAPP';

  constructor(
    public appStorage: AppStorage,
    private loginService: LoginService,
    private router: Router
  ) {
    this.appStorage.loadingSesion = true;

    let token;
    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token');
    } else if (sessionStorage.getItem('token')) {
      token = sessionStorage.getItem('token');
    }
    if (token) {
      this.appStorage.token = token;
      this.loginService
        .getDatosSesion()
        .then((res: any) => {
          this.appStorage.datosSesion = {
            usuario: res.usuario,
            perfil: res.idperfil
          };
          this.appStorage.conSesion = true;
          this.appStorage.loadingSesion = false;
          if (this.router.url === '/') {
            this.router.navigate(['/admin']);
          }
        })
        .catch(error => {
          this.appStorage.token = undefined;
          this.appStorage.conSesion = false;
          this.appStorage.loadingSesion = false;
        });
    } else {
      this.appStorage.loadingSesion = false;
      this.appStorage.conSesion = false;
      // Pagina sin sesion
    }
  }
}
